export const getInitialsFromDisplayName = (name: string) => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const firstWord = words[0] ?? '';
  const lastWord = words.length > 1 ? (words.at(-1) ?? '') : '';

  return `${firstWord.charAt(0)}${lastWord.charAt(0)}`.toUpperCase();
};
